import React from "react";
import { Button, Avatar } from "antd";
import { LeftOutlined, UserOutlined } from "@ant-design/icons";

const RequestMoneyConfirm = ({ data, onBack, onConfirm }) => (
  <div
    style={{
      maxWidth: 480,
      margin: "0 auto",
      minHeight: "100vh",
      background: "#fff",
      display: "flex",
      flexDirection: "column",
      padding: "0 20px",
      boxSizing: "border-box",
    }}
  >
    {/* Header */}
    <div style={{ display: "flex", alignItems: "center", padding: "16px 0" }}>
      <LeftOutlined
        style={{ fontSize: 20, cursor: "pointer", color: "#2e3a59" }}
        onClick={onBack}
      />
      <div
        style={{
          flex: 1,
          textAlign: "center",
          fontWeight: 600,
          fontSize: 18,
          color: "#2e3a59",
        }}
      >
        Request money
      </div>
    </div>

    {/* Details */}
    <div style={{ flex: 1, marginTop: 16 }}>
      <div style={{ marginBottom: 20 }}>
        <div style={{ color: "#8493ad", fontSize: 14, fontWeight: 500 }}>
          Request Money from
        </div>
        <div style={{ display: "flex", gap: 12, marginTop: 8 }}>
          {/* Example: multiple users */}
          <div style={{ textAlign: "center" }}>
            <Avatar size={48} icon={<UserOutlined />} />
            <p style={{ marginTop: 6, fontSize: 13, fontWeight: 500 }}>
              {data?.to || "User"}
            </p>
          </div>
        </div>
      </div>

      <div style={{ marginBottom: 20 }}>
        <div style={{ color: "#8493ad", fontSize: 14, fontWeight: 500 }}>
          Reason
        </div>
        <div style={{ color: "#22314a", fontWeight: 600, fontSize: 16 }}>
          {data?.requestReason || "-"}
        </div>
      </div>

      <div style={{ marginBottom: 20 }}>
        <div style={{ color: "#8493ad", fontSize: 14, fontWeight: 500 }}>
          Amount
        </div>
        <div style={{ color: "#22314a", fontWeight: 600, fontSize: 16 }}>
          {data?.amount || "-"}
        </div>
      </div>
    </div>

    {/* Confirm Button */}
    <div style={{ marginBottom: 100 }}>
      <Button
        type="primary"
        block
        style={{
          background: "linear-gradient(90deg,#021b79,#0575E6)",
          border: "none",
          borderRadius: 12,
          color: "#fff",
          fontWeight: 600,
          fontSize: 16,
          height: 48,
        }}
        onClick={onConfirm}
      >
        Confirm
      </Button>
    </div>
  </div>
);

export default RequestMoneyConfirm;
